import React from 'react';
import '../styles/PrivacyPolicy.css';
import { API_BASE_URL } from "../environment";
import { API } from "../common/Constants";
import LoadingSpinner from '../components/LoadingSpinner';
import PrivacyPolicyData from '../data/PrivacyPolicy.json';

const PrivacyPolicy = () => {
  const [privacyPolicy, setPrivacyPolicy] = React.useState();
  const [loading, setLoading] = React.useState(false);


  React.useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}${API.PRIVACY_POLICY}`);
      const data = await response.json();
      if (response.ok) {
        setPrivacyPolicy(JSON.parse(data?.content));
      } else {
        console.error("Failed to fetch privacy policy:", data);
      }
      setLoading(false);
    };

    fetchPrivacyPolicy();
    //setPrivacyPolicy(PrivacyPolicyData);
  }, []);

  const renderContent = (content) => {
    if (!content) return null;

    return content?.map((item, index) => {
      switch (item.type) {
        case 'h1':
          return (
            <div key={index} className="policy-section-main">
              <h1 className="policy-h1" dangerouslySetInnerHTML={{ __html: item.text || '' }} />
              {item.content && renderContent(item.content)}
            </div>
          );
        case 'h2':
          return (
            <div key={index} className="policy-section-sub">
              <h2 className="policy-h2" dangerouslySetInnerHTML={{ __html: item.text || '' }} />
              {item.content && renderContent(item.content)}
            </div>
          );
        case 'h3':
          return (
            <div key={index} className="policy-section">
              <h3 className="policy-h3" dangerouslySetInnerHTML={{ __html: item.text || '' }} />
              {item.content && renderContent(item.content)}
            </div>
          );
        case 'paragraph':
          return (
            <div key={index}>
              <p className="policy-paragraph" dangerouslySetInnerHTML={{ __html: item.text || '' }} />
              {item.content && renderContent(item.content)}
            </div>
          );
        case 'ul':
          return (
            <ul key={index} className="policy-list">
              {item.items && item.items.map((listItem, listIndex) => (
                <li key={listIndex} className="policy-list-item">
                  <span dangerouslySetInnerHTML={{ __html: listItem.text || '' }} />
                  {listItem.content && renderContent(listItem.content)}
                </li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };


  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="policy-container">
      <h1 className="policy-main-heading" dangerouslySetInnerHTML={{ __html: privacyPolicy?.heading || '' }} />
      {renderContent(privacyPolicy?.content)}
      <div className="policy-last-updated">
        <p>Last updated: June 8, 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;